export interface Stats {
  accounts: number; enabledAccounts: number; requestsToday: number; requestsTotal: number;
  tokensToday: number; tokensTotal: number;
  topAccounts: { accountName: string; requests: number; tokens: number }[];
}
export interface UsageRecord {
  ts: number; accountId: string; accountName: string; model: string; stream: boolean;
  promptTokens: number; completionTokens: number; ok: boolean; ms: number; error?: string;
}
export interface ClientAccount {
  id: string; name: string; email?: string; token: string; enabled: boolean; model?: string;
  createdAt: number; lastUsedAt?: number;
}
export interface Settings {
  provider: { preset: string; baseUrl: string; apiKey: string; model: string; temperature: number; maxTokens: number };
  gatewayEnabled: boolean;
}

let token = localStorage.getItem('xlb_admin_token') ?? '';

export function setToken(t: string) { token = t; localStorage.setItem('xlb_admin_token', t); }
export function clearToken() { token = ''; localStorage.removeItem('xlb_admin_token'); }
export function getToken() { return token; }

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = 'Bearer ' + token;
  let payload: string | undefined;
  if (body !== undefined) { headers['Content-Type'] = 'application/json'; payload = JSON.stringify(body); }
  const r = await fetch('/api' + path, { method, headers, body: payload });
  const text = await r.text();
  let json: unknown = null;
  try { json = text ? JSON.parse(text) : null; } catch { json = text; }
  if (!r.ok) {
    const err = (json as { error?: string } | null)?.error || String(json || r.status);
    if (r.status === 401) { clearToken(); }
    throw new Error(err);
  }
  return json as T;
}

export const api = {
  login: (username: string, password: string) => req<{ token: string; username: string }>('POST', '/auth/login', { username, password }),
  changePassword: (oldPassword: string, newPassword: string) => req<{ ok: boolean }>('POST', '/auth/change-password', { oldPassword, newPassword }),
  stats: () => req<Stats>('GET', '/admin/stats'),
  usage: (limit = 100) => req<UsageRecord[]>('GET', '/admin/usage?limit=' + limit),
  accounts: () => req<ClientAccount[]>('GET', '/admin/accounts'),
  createAccount: (name: string, email?: string, model?: string) => req<ClientAccount>('POST', '/admin/accounts', { name, email, model }),
  patchAccount: (id: string, patch: { enabled?: boolean; model?: string; name?: string }) => req<ClientAccount>('PATCH', '/admin/accounts/' + id, patch),
  resetToken: (id: string) => req<{ token: string }>('POST', '/admin/accounts/' + id + '/reset-token'),
  deleteAccount: (id: string) => req<{ ok: boolean }>('DELETE', '/admin/accounts/' + id),
  getSettings: () => req<Settings>('GET', '/admin/settings'),
  putSettings: (provider: Settings['provider']) => req<Settings>('PUT', '/admin/settings', { provider }),
  testSettings: (baseUrl: string, apiKey: string) => req<{ ok: boolean; message: string }>('POST', '/admin/settings/test', { baseUrl, apiKey }),
};
